
import { transformToString } from '../../libs/utils'

export const CHANGE_LANGUAGE = 'app/CHANGE_LANGUAGE';
export const changeLanguage = newLanguage => ({
  type: CHANGE_LANGUAGE,
  payload: newLanguage,
})

export const SET_LANGUAGE_RESOURCE = 'app/SET_LANGUAGE_RESOURCE';
export const setLanguageResource = newLanguage => ({
  type: SET_LANGUAGE_RESOURCE,
  payload: newLanguage,
});

export const SET_ACCOUNT_TIME_ZONE = 'app/SET_ACCOUNT_TIME_ZONE';
export const setAccountTimeZone = timeZone => ({
  type: SET_ACCOUNT_TIME_ZONE,
  payload: timeZone,
});

export const LOGIN_BY_PARAMETERS_FROM_URL = 'app/LOGIN_BY_PARAMETERS_FROM_URL';
export const loginByParametersFromURL = ({ accountName, passwordMD5 }) => ({
  type: LOGIN_BY_PARAMETERS_FROM_URL,
  payload: { accountName, passwordMD5 },
});

export const SELECT_COLOR_THEME = 'app/SELECT_COLOR_THEME';
export const selectColorTheme = newColorTheme => ({
  type: SELECT_COLOR_THEME,
  payload: newColorTheme,
});

export const USE_PARAMS_FROM_URL = 'app/USE_PARAMS_FROM_URL';
export const useParamsFromUrl = () => ({
  type: USE_PARAMS_FROM_URL,
});

export const FIRST_START = 'app/FIRST_START';
export const firstStart = () => ({
  type: FIRST_START,
});

export const SHOW_FULL_SCREEN_SPINNER = 'app/SHOW_FULL_SCREEN_SPINNER';
export const showFullScreenSpinner = () => ({
  type: SHOW_FULL_SCREEN_SPINNER,
});

export const HIDE_FULL_SCREEN_SPINNER = 'app/HIDE_FULL_SCREEN_SPINNER';
export const hideFullScreenSpinner = () => ({
  type: HIDE_FULL_SCREEN_SPINNER,
});

export const SHOW_LOADING_BAR = 'app/SHOW_LOADING_BAR';
export const showLoadingBar = params => ({
  type: SHOW_LOADING_BAR,
  payload: params,
});

/* notifications */
const notificationsTypes = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
};
export const CREATE_NOTIFICATION = 'app/CREATE_NOTIFICATION';
export const createNotification = ({ type, message, title, timeOut, callback, priority }) => ({
  type: CREATE_NOTIFICATION,
  payload: {
    type,
    params: [
      transformToString(message),
      title || '',
      timeOut || 0,
      callback,
      priority || false,
    ],
  },
});
export const showError = (message, notificationParams) => createNotification({
  type: notificationsTypes.ERROR,
  message,
  // callback: () => document.location.href = `https://stackoverflow.com/search?q=${transformToString(message)}`,
  ...notificationParams,
})
export const SHOW_ALERT = 'app/SHOW_ALERT';
export const showAlert = params => ({
  type: SHOW_ALERT,
  payload: { ...params, timeOut: 5e3 },
})

/* POPUP */
export const OPEN_POPUP = 'app/OPEN_POPUP';
export const openPopup = popupParams => ({
  type: OPEN_POPUP,
  payload: popupParams,
});

export const CLOSE_POPUP = 'app/CLOSE_POPUP';
export const closePopup = () => ({
  type: CLOSE_POPUP,
});
